import {FormSessionDto} from "../../client/formsession/FormSessionApiClient";
import {Stack} from "@mui/material";
import React from "react";
import {FormSessionTranslKey} from "./FormSessionTranslKey";
import {useTranslation} from "react-i18next";
import {DateTimeFormatter} from "../../common/DateTimeFormatter";
import {DetailsTable} from "../../common/details/DetailsTable";
import {DetailsTextRow} from "../../common/details/DetailsTextRow";
import {formatUserLastNameFirst} from "../user/UserFormatter";
import {CatalogType} from "../../client/catalog/CatalogType";

export interface FormSessionDetailPanelProps {
    formSession: FormSessionDto;
}

export default function FormSessionBasicDetailPanel(props: Readonly<FormSessionDetailPanelProps>) {
    const {formSession} = props;

    const {t} = useTranslation();
    const createdAt = DateTimeFormatter.formatDateTime(formSession.createdAt);

    return (
        <Stack spacing={2} padding={1}>
            <DetailsTable>
                <DetailsTextRow label={t(FormSessionTranslKey.ACCESSED_AT)}
                                value={createdAt ?? undefined}/>

                <DetailsTextRow label={t(FormSessionTranslKey.DOCUMENT_TYPE)}
                                value={t(formSession.documentType ?? '', {ns: CatalogType.DOCUMENT_TYPE})}/>

                <DetailsTextRow label={t(FormSessionTranslKey.DOCUMENT_VERSION)}
                                value={formSession.documentVersion}/>

                <DetailsTextRow label={t(FormSessionTranslKey.USER)}
                                value={formatUserLastNameFirst(formSession.user)}/>

                <DetailsTextRow label={t(FormSessionTranslKey.EMAIL)}
                                value={formSession.user?.person?.email}/>

                <DetailsTextRow label={t(FormSessionTranslKey.PHONE)}
                                value={formSession.user?.person?.phone}/>

                <DetailsTextRow label={t(FormSessionTranslKey.DATOVA_SCHRANKA)}
                                value={formSession.user?.person?.databox}/>
            </DetailsTable>
        </Stack>
    );
}
